<div class="inputTitle" *ngIf="label">
    <span>{{label}}<i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
            id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>

<mat-form-field appearance="outline" [hidden]="!isEditable" (focusout)="onFocusOut($event)"
    (focusin)="onFocusIn($event)" [class.errorBorder]="errors?.length">
    <input matInput type="text" [placeholder]="placeholder" [name]="name" [ngModel]="data"
        (ngModelChange)="setData($event)" [id]="name" [disabled]="disabled" [min]="minlength" [max]="maxlength"
        autocomplete="off">
</mat-form-field>

<div class="suggestion-container dropdown" *ngIf="options.length && isEditable && showOptions"
    (focusout)="onFocusOut($event)" (focusin)="onFocusIn($event)">


    <div class="loading hover" *ngIf="loading">
        Loading...
    </div>
    <div class="suggestions hover" *ngIf="!loading">
        <div class="title">
            {{hintText}}
        </div>

        <div class="item" *ngFor="let option of options" (click)="onOptionSelected(option)">
            <span class="itemInfo">
                {{option[displayField]}}
            </span>
            <span>
                <i [class]="itemIcon"></i>
            </span>
        </div>
    </div>
</div>



<div class="viewLable" *ngIf="!isEditable">
    <span>{{_data}}</span>
</div>


<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{item}}</li>
</ul>